import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useState } from "react";
import StoreCashHandoverDialog from "./store-cash-handover-dialog";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Tag } from "primereact/tag";
import { DataTableRowClickEvent } from "primereact/datatable";
import CombinedCashTraceDialog from "./CombinedCashTraceDialog";

interface StoreCashRow {
  invoiceDate: string;
  userID: number;
  invoicedBy: string;
  totalSubTotal: number;
  totalTaxAmount: number;
  totalCourierCharges: number;
  totalDiscountAmount: number;
  grossAmount: number;
  acceptedCashAmount: number;
  totalCollection: number;
  // isSettled?: boolean;
  handoverAmount: number;
  unsettledAmount: number;
}

interface StoreCashDatatableProps {
  data: StoreCashRow[];
  loading: boolean;
  refreshData: () => void;
}

const StoreCashDatatable: React.FC<StoreCashDatatableProps> = ({
  data,
  loading,
  refreshData,
}) => {
  const toast = useRef<Toast>(null);
  const [showHandoverDialog, setShowHandoverDialog] = useState(false);
  const [handoverData, setHandoverData] = useState<StoreCashRow | null>(null);
  const [selectedRow, setSelectedRow] = useState<StoreCashRow | null>(null);
const [showTraceDialog, setShowTraceDialog] = useState(false);

  const sortedData = [...data].sort(
    (a, b) => new Date(b.invoiceDate).getTime() - new Date(a.invoiceDate).getTime()
  );

  const formatDate = (rowData: StoreCashRow) => {
    const dt = new Date(rowData.invoiceDate);
    return dt.toLocaleDateString("en-GB");
  };

  const actionBodyTemplate = (rowData: StoreCashRow) => {
      const isSettled =
    rowData.totalCollection === rowData.handoverAmount &&
    rowData.unsettledAmount === 0;

    const handleSendToAccounts = () => {
      setHandoverData(rowData);
      setShowHandoverDialog(true);
    };
    
    

    return (
      <div className="flex justify-content">
        <Button
          label="Send to Accounts"
          icon="pi pi-send"
          iconPos="left"
          severity="success"
          size="small"
          disabled={isSettled}
          onClick={handleSendToAccounts}
          className="text-sm px-3"
          // disabled={rowData.isSettled} 
        />
      </div>
    );
  };

 const statusBodyTemplate = (rowData: StoreCashRow) => {
      let status = "Pending";
      let severity: "success" | "warning" | "danger" | undefined = "warning";
    
      if (rowData.totalCollection === rowData.handoverAmount && rowData.unsettledAmount === 0) {
        status = "Settled";
        severity = "success"; // Green
      } else if (rowData.handoverAmount > 0 && rowData.unsettledAmount > 0) {
        status = "Partially Settled";
        severity = "warning"; // Yellow
      } else if (rowData.handoverAmount === 0 && rowData.unsettledAmount === rowData.totalCollection) {
        status = "Pending";
        severity = "danger"; // Red
      }
    
      return <Tag value={status} severity={severity} />;
    };

    const handleRowClick = (e: DataTableRowClickEvent) => {
      debugger
  setSelectedRow(e.data as StoreCashRow);
  setShowTraceDialog(true);
};

  return (
    <div className="card border-noround p-2">
      <Toast ref={toast} position="top-right" />

      <DataTable
        value={sortedData}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        onRowClick={handleRowClick}
      >
        <Column header="Date" body={formatDate} style={{ width: "15%" }} />
        <Column field="totalCollection" header="Total Cash Collected" style={{ width: "15%" }} />
        <Column field="handoverAmount" header="Settled" style={{ width: "15%" }} />
        <Column field="unsettledAmount" header="Unsettled" style={{ width: "15%" }} />
        <Column field="Status" header="Status" style={{ width: "15%" }} body={statusBodyTemplate}/>

        <Column header="Action" body={actionBodyTemplate} style={{ width: "20%" }} />
      </DataTable>

      {/* Only render dialog when handoverData is not null */}
      {handoverData && (
        <StoreCashHandoverDialog
          visible={showHandoverDialog}
          onHide={() => {
            setShowHandoverDialog(false);
            setHandoverData(null); // Reset data
            refreshData();
          }}
          data={handoverData}
          setLoading={() => {}}
           toastRef={toast}
        />
      )}

      {selectedRow && (
  <CombinedCashTraceDialog
    visible={showTraceDialog}
    onHide={() => setShowTraceDialog(false)}
    userID={selectedRow.userID}
    userName={selectedRow.invoicedBy}
    startDate={selectedRow.invoiceDate}
    endDate={selectedRow.invoiceDate} 
  />
)}
    </div>
  );
};

export default StoreCashDatatable;
